var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('HeadInfo'),_c('div',{staticClass:"tipSty"},[_c('div',[_vm._v(" 本周概要（"+_vm._s(_vm.filterTime(_vm.weekData.week_start))+"-"+_vm._s(_vm.filterTime(_vm.weekData.week_end))+"） ")])]),_c('DurationStudy',{attrs:{"particulas":_vm.weekData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }